/**
 * signoffsreducer.js
 * Created by calhosh on 10/22/2020.
 */
import initialState from './initialstate';
import * as types from '../actions/actiontypes';
import _ from 'lodash';
import {normalize} from '../util/utils';

export default function signOffsReducer(state = initialState.signOffs, action) {
	switch (action.type) {
		case types.SET_APPROVALS: {
			if (action.approvals && action.approvals.length > 0) {
				action.approvals.map((approval) => {
					approval.approvalId = approval.id;
					approval.documentId = action.documentId;
				});
				return normalize(action.approvals, undefined, state);
			} else {
				return normalize();
			}
		}
		case types.ADD_APPROVAL: {
			if (action.response) {
				action.response.id = action.response.approvalId;
				return normalize([action.response], undefined, state);
			}
			return state;
		}
		case types.CREATE_SNAPSHOT: {
			return state.documentSignOffs || state;
		}
		case types.DELETE_APPROVAL: {
			let signOffs = _.cloneDeep(state);
			delete signOffs.byId[action.meta.api.data.approvalId];
			return {
				allIds: signOffs.allIds.filter((id) => id !== action.meta.api.data.approvalId),
				byId: {...signOffs.byId}
			};
		}
		case types.GET_DOCUMENT_SIGN_OFFS:
			if (action.response && action.response.length > 0) {
				for (let i = 0; i < action.response.length; i++) {
					action.response[i].id = action.response[i].approvalId;
				}
				return normalize(action.response, undefined, state);
			}
			else {
				return normalize();
			}
		case types.GET_ALL_DOCUMENTS:
		case types.MARK_COMPLETE_GET_DOCUMENTS:
			if (action.response) {
				return applyResponse(state, action.response.data);
			}
			break;
		case types.ARES_GET_DOCUMENT_BY_ID:
			if(action.response){
				return applyResponse(state, [action.response]);
			}
			break;
		default:
			return state.documentSignOffs || state;
	}
}

function applyResponse(state, documents) {
	let approvals = [];

	// Add document ID to approvals:
	for (let i = 0; i < documents?.length; i++) {
		documents[i].approvals.documentId = documents[i].id;
		approvals = approvals.concat(documents[i].approvals);
	}

	return normalize(approvals, undefined, state);
}
